import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const ivTherapyServices = [
  {
    serviceId: 'IV_001',
    serviceName: 'Rehydration Therapy',
    category: 'IV Therapy',
    specialty: null,
    subCategory: 'Hydration',
    description: 'Intravenous fluid replacement for dehydration and electrolyte imbalance',
    cost: 450,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'IV_REHYDRATE',
    billableItems: [
      {
        itemId: 'IV_001',
        itemName: 'IV fluids and administration set',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['iv', 'hydration', 'fluids'],
    displayOrder: 1
  },
  {
    serviceId: 'IV_002',
    serviceName: 'Vitamin Drip',
    category: 'IV Therapy',
    specialty: null,
    subCategory: 'Nutritional Therapy',
    description: 'Intravenous vitamin and mineral supplementation for wellness',
    cost: 650,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'IV_VITAMIN',
    billableItems: [
      {
        itemId: 'IV_002',
        itemName: 'Vitamin cocktail and IV set',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['iv', 'vitamins', 'wellness'],
    displayOrder: 2
  },
  {
    serviceId: 'IV_003',
    serviceName: 'Iron Infusion',
    category: 'IV Therapy',
    specialty: 'Hematology',
    subCategory: 'Iron Deficiency Treatment',
    description: 'Intravenous iron replacement therapy for iron deficiency anemia',
    cost: 850,
    durationMinutes: 90,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'IV_IRON',
    billableItems: [
      {
        itemId: 'IV_003',
        itemName: 'Iron sucrose and IV administration',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['iv', 'iron', 'anemia'],
    displayOrder: 3
  },
  {
    serviceId: 'IV_004',
    serviceName: 'Anti-nausea IV Therapy',
    category: 'IV Therapy',
    specialty: null,
    subCategory: 'Symptom Relief',
    description: 'Intravenous anti-emetic medication for severe nausea and vomiting',
    cost: 400,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'IV_ANTINAUSEA',
    billableItems: [
      {
        itemId: 'IV_004',
        itemName: 'Anti-emetic medication and IV set',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['iv', 'nausea', 'anti-emetic'],
    displayOrder: 4
  },
  {
    serviceId: 'IV_005',
    serviceName: 'Hangover Recovery Drip',
    category: 'IV Therapy',
    specialty: null,
    subCategory: 'Recovery Therapy',
    description: 'IV hydration and vitamin therapy for hangover recovery',
    cost: 550,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'IV_HANGOVER',
    billableItems: [
      {
        itemId: 'IV_005',
        itemName: 'Hangover recovery cocktail and IV set',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['iv', 'hangover', 'recovery'],
    displayOrder: 5
  },
  {
    serviceId: 'IV_006',
    serviceName: 'Immune Boost IV',
    category: 'IV Therapy',
    specialty: null,
    subCategory: 'Immune Support',
    description: 'High-dose vitamin C and immune-boosting nutrients via IV',
    cost: 700,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'IV_IMMUNE',
    billableItems: [
      {
        itemId: 'IV_006',
        itemName: 'Immune boost cocktail and IV set',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['iv', 'immune', 'vitamin-c'],
    displayOrder: 6
  }
]

export default ivTherapyServices
